export const isInstructorStripeComplete = (stripeStatus) => (
  Boolean(stripeStatus?.payouts_enabled && stripeStatus?.charges_enabled)
);

export const getInstructorStripeStatus = async ({
  functions,
  httpsCallable,
  instructorId,
  stripeToken,
}) => {
  if (!instructorId) throw new Error('Instructor ID is required');
  if (!stripeToken) return null;

  const getAccountDetails = httpsCallable(functions, 'getAccountDetails');
  const result = await getAccountDetails({ accountId: stripeToken, userId: instructorId });
  return result?.data || null;
};

const normalizeEmail = (email) => String(email || '').trim().toLowerCase();

export const getInstructorStripeSetupLink = async ({
  functions,
  httpsCallable,
  instructorId,
  stripeToken,
  email,
}) => {
  if (!instructorId) throw new Error('Instructor ID is required');

  if (!stripeToken) {
    const normalizedEmail = normalizeEmail(email);
    if (!normalizedEmail) throw new Error('Instructor email is required to create a Stripe account.');

    const createConnectedAccount = httpsCallable(functions, 'createConnectedAccount');
    const createResult = await createConnectedAccount({
      userId: instructorId,
      email: normalizedEmail,
      url: 'https://www.fitgroupusa.com/',
      product_description: 'Fit Group USA instructor payouts',
    });

    if (!createResult?.data?.connectedAccountId) {
      throw new Error('Stripe did not return a connected account ID.');
    }
  }

  const initiateAccountLink = httpsCallable(functions, 'initiateAccountLink');
  const result = await initiateAccountLink({
    userId: instructorId,
    return_url: 'https://instructor.fitgroupusa.com',
    refresh_url: 'https://instructor.fitgroupusa.com',
  });
  return result?.data?.accountLinkUrl || '';
};
